import { Typography } from "@mui/material";
import React from "react";
import { DEFAULT_TIMEZONE, TIMEZONE_OPTIONS } from "@consts";
import AccountEditorFields from "./AccountEditorFields";
import useAccountEditorController from "./useAccountEditorController";
import Drawer from "@hyro-components/Drawer/Drawer";

const AccountEditorDrawer = ({
  open,
  onClose,
  onSubmit,
  onResetError,
  accountData,
  type,
  error,
  errorText
}) => {
  const {
    newAccountData,
    dialogContent,
    isLoading,
    isSaveDisabled,
    handleTextFieldChange,
    handleDirectSubmit
  } = useAccountEditorController({
    accountData,
    type,
    error,
    errorText,
    onConfirm: onSubmit,
    onResetError
  });

  const timezoneOptions = TIMEZONE_OPTIONS.map((option) =>
    option.key === DEFAULT_TIMEZONE ? { ...option, chipText: "System default" } : option
  );

  return (
    <Drawer
      isOpen={open}
      onClose={onClose}
      isSubmitLoading={isLoading}
      isSubmitDisabled={isSaveDisabled}
      onSubmit={handleDirectSubmit}
    >
      <Typography variant="h6" color="text.800">
        {dialogContent?.title}
      </Typography>

      <AccountEditorFields
        type={type}
        data={newAccountData}
        timezoneOptions={timezoneOptions}
        onChange={handleTextFieldChange}
      />
    </Drawer>
  );
};

export default AccountEditorDrawer;

